import { Button, Card, Form, InputNumber } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  buttonLabel,
  cardConfig,
  formConfig,
  label,
  messages,
} from '../../../../constants';
import { useEffect, useState } from 'react';
import { updateConfigs } from '../../../../appRedux/actions';
import { useCustomModal } from '../../../../hooks/useCustomModal';

export const SettingsAbscenceTimeModalForm = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const { configs } = useSelector((state) => state.configs);
  const [form] = Form.useForm();
  const { setShowModal } = useCustomModal();
  const [isLoading, setIsLoading] = useState(false);
  const [configId, setConfigId] = useState();
  const [response, setResponse] = useState();

  const validateIdleTime = (_, value) => {
    if (value && value > 0) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('El tiempo de inactividad debe ser mayor a 0 segundos'));
  };

  useEffect(() => {
    setConfigId(configs?.id);
  }, [configs?.id]);

  useEffect(() => {
    if ([200, 201].includes(response)) {
      setShowModal(false);
      if (onSuccess) {
        onSuccess();
      }
    }
  }, [response, setShowModal, onSuccess]);

  useEffect(() => {
    if (configs?.abscenceTime) {
      form.setFieldsValue({
        abscenceTime: {
          freezeScreen: configs.abscenceTime.freezeScreen || 0,
          idleTime: configs.abscenceTime.idleTime || 0,
        },
      });
    }
  }, [configs, form]);

  const onSubmit = async (values) => {
    setIsLoading(true);
    if (configId) {
      setResponse(await dispatch(updateConfigs(configId, values)));
    }
    setIsLoading(false);
  };

  return (
    <Card size="small" bordered={true} style={cardConfig}>
      <Form
        autoComplete="off"
        onFinish={onSubmit}
        form={form}
        {...formConfig}
        labelCol={{ xs: { span: 24 }, sm: { span: 8 } }}
        labelWrap
      >
        <Form.Item
          name={['abscenceTime', 'freezeScreen']}
          label={label.freezeScreen}
          rules={[
            {
              required: true,
              message: messages.freezeScreen,
            },
          ]}
        >
          <InputNumber min={1} />
        </Form.Item>
        <Form.Item
          name={['abscenceTime', 'idleTime']}
          label={label.idleSrceen}
          rules={[
            {
              required: true,
              message: messages.idleScreen,
            },

            {
              validator: validateIdleTime,
            },
          ]}
        >
          <InputNumber min={1} />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="btn-form"
            loading={isLoading}
          >
            {buttonLabel.save}
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};
